// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"609":"021e3eec","772":"f1e75317"}[chunkId] + ".chunk.css";
};